import uniqid from 'uniqid';

export default {
    /**
     * Opens/closes service appointment report modal.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_REPORT_MODAL (state, data) {
        state.isOpen = data.open;
        state.appointmentId = data.id;

        if (data.open === true) {
            return;
        }

        state.appointment = {};
        state.report = {};
        state.errors = {};
        state.damageOpen = null;
        state.testOpen = null;
        state.actionWithReason.isOpen = false;
        state.confirmation.isOpen = false;
    },

    /**
     * Sets initial service appointment report modal data from service appointment.
     *
     * @param state State object
     * @param data Data object
     */
    SET_REPORT_MODAL_DATA (state, data) {
        state.appointment = data;
        state.report = data.report ? JSON.parse(JSON.stringify(data.report)) : {};
    },

    /**
     * Updated service appointment report data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_APPOINTMENT_REPORT (state, data) {
        state.appointment.report = data;
    },

    /**
     * Sets just report data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_REPORT_DATA (state, data) {
        let keys = Object.keys(data);

        for (let i = 0; i < keys.length; i++) {
            // Makes non-existent property reactive
            this._vm.$set(state.report, keys[i], data[keys[i]]);
        }
    },

    /**
     * Sets service appointment report modal validation errors.
     *
     * @param state State object
     * @param data Errors
     */
    SET_REPORT_MODAL_ERRORS (state, data) {
        state.errors = data;
    },

    /**
     * Toggles action with reason block.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_ACTION_WITH_REASON (state, data) {
        if (data.open) {
            state.actionWithReason.action = data.action;
            state.actionWithReason.isOpen = data.open;

            return;
        }

        state.actionWithReason.isOpen = data.open;
        state.actionWithReason.action = '';
        state.actionWithReason.reason = '';
        state.actionWithReason.errors = {};
    },

    /**
     * Sets action with reason, reason value.
     *
     * @param state State object
     * @param data Data object
     */
    SET_ACTION_REASON (state, data) {
        state.actionWithReason.reason = data;
    },

    /**
     * Sets action with reason errors.
     *
     * @param state State object
     * @param data Data object
     */
    SET_ACTION_ERRORS (state, data) {
        state.actionWithReason.errors = data;
    },

    /**
     * Toggles service appointment report checkbox value.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_CHECKBOX (state, data) {
        for (let i = 0; i < state.report[data.field].length; i++) {
            if (state.report[data.field][i].id === data.id) {
                state.report[data.field][i].value = !state.report[data.field][i].value;

                break;
            }
        }
    },

    /**
     * Adds file object to given field.
     *
     * @param state State object
     * @param data Data object
     */
    ADD_FILE (state, data) {
        if (typeof state.report[data.field] === 'undefined') {
            // Makes non-existent property reactive
            this._vm.$set(state.report, data.field, []);
        }

        // A hack for uninitialized field
        if (data.file !== null) {
            state.report[data.field].push(data.file);
        }
    },

    /**
     * Removes file object from given field.
     *
     * @param state State object
     * @param data Data object
     */
    REMOVE_FILE (state, data) {
        state.report[data.field].splice(data.index, 1);
    },

    /**
     * Toggles is uploading indicator.
     *
     * @param state State object
     * @param isUploading Is uploading
     */
    TOGGLE_IS_UPLOADING (state, isUploading) {
        state.isUploading = isUploading;
    },

    /**
     * Sets service appointment report creation information.
     *
     * @param state State object
     * @param data Data object
     */
    SET_CREATE_INFORMATION (state, data) {
        let keys = Object.keys(data);

        for (let i = 0; i < keys.length; i++) {
            this._vm.$set(state.report, keys[i], data[keys[i]]);
        }
    },

    /**
     * Adds empty damage object.
     *
     * @param state State object
     * @param id Random ID
     */
    ADD_DAMAGE (state, id) {
        if (typeof state.report.damages === 'undefined') {
            // Makes non-existent property reactive
            this._vm.$set(state.report, 'damages', []);
        }

        let temp = JSON.parse(JSON.stringify(state.examples.damage));

        temp.id = id;

        state.report.damages.push(temp);
    },

    /**
     * Adds empty damage object.
     *
     * @param state State object
     * @param data data object
     */
    ADD_TEXT_WITH_IMAGE (state, data) {
        if (typeof state.report.text_with_images === 'undefined') {
            // Makes non-existent property reactive
            this._vm.$set(state.report, 'text_with_images', []);
        }

        state.report.text_with_images.push({
            id: data.id,
            title: data.title,
            value: '',
            field_images: [],
            data_type: 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportTextWithImageField',
        });
    },

    /**
     * Sets text with image data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_TEXT_WITH_IMAGE_DATA (state, data) {
        let keys = Object.keys(data.data);

        for (let i = 0; i < keys.length; i++) {
            // Makes non-existent property reactive
            this._vm.$set(state.report.text_with_images[data.index], keys[i], data.data[keys[i]]);
        }
    },

    /**
     * Adds file object to given field.
     *
     * @param state State object
     * @param data Data object
     */
    ADD_TEXT_WITH_IMAGE_FILE (state, data) {
        // A hack for uninitialized field
        if (data.file !== null) {
            state.report.text_with_images[data.index][data.field].push(data.file);
        }
    },

    /**
     * Removes file object from given field.
     *
     * @param state State object
     * @param data Data object
     */
    REMOVE_TEXT_WITH_IMAGE_FILE (state, data) {
        state.report.text_with_images[data.index][data.field].splice(data.fileIndex, 1);
    },

    /**
     * Adds empty damage object.
     *
     * @param state State object
     * @param data Data object
     */
    ADD_QR_DAMAGE (state, data) {
        if (typeof state.report.damages === 'undefined') {
            // Makes non-existent property reactive
            this._vm.$set(state.report, 'damages', []);
        }

        let temp = JSON.parse(JSON.stringify(data.damage));

        temp.id = data.id;

        const items = {
            elements: {
                accessories: 'accessories',
                fillers: 'fillers',
                handles: 'handles',
                sashes: 'sashes',
            },
            mullions: {
                horizontal: 'horizontal_mullions',
                vertical: 'vertical_mullions',
            },
        };

        const topKeys = Object.keys(items);

        for (let i = 0; i < topKeys.length; i++) {
            const subKeys = Object.keys(items[topKeys[i]]);

            for (let j = 0; j < subKeys.length; j++) {
                for (let k = 0; k < temp.position[topKeys[i]][subKeys[j]].length; k++) {
                    temp[items[topKeys[i]][subKeys[j]]].push({
                        id: uniqid(),
                        name: temp.position[topKeys[i]][subKeys[j]][k],
                        value: false,
                        data_type: 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportDamagePositionItem',
                    });
                }
            }
        }

        state.report.damages.push(temp);
    },

    /**
     * Sets damage data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_DAMAGE_DATA (state, data) {
        let keys = Object.keys(data.data);

        for (let i = 0; i < keys.length; i++) {
            // Makes non-existent property reactive
            this._vm.$set(state.report.damages[data.index], keys[i], data.data[keys[i]]);
        }
    },

    /**
     * Adds damage object.
     *
     * @param state State object
     * @param index Damage index
     */
    REMOVE_DAMAGE (state, index) {
        state.report.damages.splice(index, 1);
    },

    /**
     * Sets open damage ID.
     *
     * @param state State object
     * @param id Damage ID
     */
    SET_OPEN_DAMAGE (state, id) {
        state.damageOpen = id;
    },

    /**
     * Adds example object.
     *
     * @param state State object
     * @param data Data object
     */
    ADD_EXAMPLE (state, data) {
        state.examples[data.field] = data.data;
    },

    /**
     * Toggles is loading indicator.
     *
     * @param state State object
     * @param isLoading Is loading
     */
    TOGGLE_IS_LOADING (state, isLoading) {
        state.isLoading = isLoading;
    },

    /**
     * Toggles service appointment report damage reference value.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_DAMAGE_REFERENCE (state, data) {
        for (let i = 0; i < state.report.damages[data.index][data.field].length; i++) {
            if (state.report.damages[data.index][data.field][i].id === data.id) {
                this._vm.$set(state.report.damages[data.index][data.field][i], 'value',
                    !state.report.damages[data.index][data.field][i].value);

                break;
            }
        }
    },

    /**
     * Toggles service appointment report damage reference values by given selected values.
     *
     * @param state State object
     * @param data Data object
     */
    SET_DAMAGE_REFERENCES (state, data) {
        let selected = [];

        for (let j = 0; j < data.selected.length; j++) {
            selected.push(data.selected[j].id);
        }

        for (let i = 0; i < state.report.damages[data.index][data.field].length; i++) {
            if ((selected.indexOf(
                state.report.damages[data.index][data.field][i].id) === -1) && (state.report.damages[data.index][data.field][i].value === true)) {
                this._vm.$set(state.report.damages[data.index][data.field][i], 'value', false);
            } else {
                if (selected.indexOf(state.report.damages[data.index][data.field][i].id) !== -1) {
                    this._vm.$set(state.report.damages[data.index][data.field][i], 'value', true);
                }
            }
        }
    },

    /**
     * Adds file object to given field.
     *
     * @param state State object
     * @param data Data object
     */
    ADD_DAMAGE_FILE (state, data) {
        // A hack for uninitialized field
        if (data.file !== null) {
            state.report.damages[data.index][data.field].push(data.file);
        }
    },

    /**
     * Removes file object from given field.
     *
     * @param state State object
     * @param data Data object
     */
    REMOVE_DAMAGE_FILE (state, data) {
        state.report.damages[data.index][data.field].splice(data.fileIndex, 1);
    },

    /**
     * Adds new service appointment damage item.
     *
     * @param state State object
     * @param data Data object
     */
    ADD_DAMAGE_ITEM (state, data) {
        state.report.damages[data.index].items.push({
            id: data.id,
            description: '',
            quantity: '',
            data_type: 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportDamageItem',
        });
    },

    /**
     * Removes service appointment damage item.
     *
     * @param state State object
     * @param data Data object
     */
    REMOVE_DAMAGE_ITEM (state, data) {
        state.report.damages[data.index].items.splice(data.itemIndex, 1);
    },

    /**
     * Sets damage item data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_DAMAGE_ITEM_DATA (state, data) {
        let keys = Object.keys(data.data);

        for (let i = 0; i < keys.length; i++) {
            // Makes non-existent property reactive
            this._vm.$set(state.report.damages[data.index].items[data.itemIndex], keys[i], data.data[keys[i]]);
        }
    },

    /**
     * Toggles confirmation modal data.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_CONFIRMATION_MODAL (state, data) {
        state.confirmation.isOpen = data.isOpen;

        if (data.isOpen) {
            state.confirmation.title = data.title;
            state.confirmation.text = data.text;
            state.confirmation.accept = data.accept;
            state.confirmation.acceptText = data.acceptText;
            state.confirmation.cancel = data.cancel;
            state.confirmation.cancelText = data.cancelText;
        } else {
            state.confirmation.title = '';
            state.confirmation.text = '';
            state.confirmation.accept = null;
            state.confirmation.acceptText = null;
            state.confirmation.cancel = null;
            state.confirmation.cancelText = null;
        }
    },

    /**
     * Toggles service appointment report reference values by given selected values.
     *
     * @param state State object
     * @param data Data object
     */
    SET_REFERENCES (state, data) {
        let selected = [];

        for (let j = 0; j < data.selected.length; j++) {
            selected.push(data.selected[j].id);
        }

        for (let i = 0; i < state.report[data.field].length; i++) {
            if ((selected.indexOf(
                state.report[data.field][i].id) === -1) && (state.report[data.field][i].value === true)) {
                this._vm.$set(state.report[data.field][i], 'value', false);
            } else {
                if (selected.indexOf(state.report[data.field][i].id) !== -1) {
                    this._vm.$set(state.report[data.field][i], 'value', true);
                }
            }
        }
    },

    /**
     * Sets open test ID.
     *
     * @param state State object
     * @param id Test ID
     */
    SET_OPEN_TEST (state, id) {
        state.testOpen = id;
    },
    SET_OPEN_NOTE (state, id) {
        state.noteOpen = id;
    },

    /**
     * Adds new service appointment test.
     *
     * @param state State object
     * @param id Test ID
     */
    ADD_TEST (state, id) {
        if (typeof state.report.tests === 'undefined') {
            // Makes non-existent property reactive
            this._vm.$set(state.report, 'tests', []);
        }

        state.report.tests.push({
            id: id,
            description: '',
            passed: null,
            test_images: [],
            data_type: 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportTest',
        });
    },
    ADD_NOTE (state, id) {
        if (typeof state.report.additionalNotes === 'undefined') {
            // Makes non-existent property reactive
            this._vm.$set(state.report, 'additionalNotes', []);
        }

        state.report.additionalNotes.push({
            id: id,
            note: '',
            images: [],
            data_type: 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportAdditionalNote',
        });
    },

    /**
     * Adds test object.
     *
     * @param state State object
     * @param index Test index
     */
    REMOVE_TEST (state, index) {
        state.report.tests.splice(index, 1);
    },

    REMOVE_NOTE (state, index) {
        state.report.additionalNotes.splice(index, 1);
    },

    /**
     * Sets test data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_TEST_DATA (state, data) {
        let keys = Object.keys(data.data);

        for (let i = 0; i < keys.length; i++) {
            // Makes non-existent property reactive
            this._vm.$set(state.report.tests[data.index], keys[i], data.data[keys[i]]);
        }
    },
    SET_NOTE_DATA (state, data) {
        let keys = Object.keys(data.data);

        for (let i = 0; i < keys.length; i++) {
            // Makes non-existent property reactive
            this._vm.$set(state.report.additionalNotes[data.index], keys[i], data.data[keys[i]]);
        }
    },

    /**
     * Adds file object to given field.
     *
     * @param state State object
     * @param data Data object
     */
    ADD_TEST_FILE (state, data) {
        // A hack for uninitialized field
        if (data.file !== null) {
            state.report.tests[data.index][data.field].push(data.file);
        }
    },
    ADD_NOTE_FILE (state, data) {
        // A hack for uninitialized field
        if (data.file !== null) {
            state.report.additionalNotes[data.index][data.field].push(data.file);
        }
    },

    /**
     * Removes file object from given field.
     *
     * @param state State object
     * @param data Data object
     */
    REMOVE_TEST_FILE (state, data) {
        state.report.tests[data.index][data.field].splice(data.fileIndex, 1);
    },
    REMOVE_NOTE_FILE (state, data) {
        state.report.additionalNotes[data.index][data.field].splice(data.fileIndex, 1);
    },
    ADD_REFERRAL (state, id) {
        if (typeof state.report.referrals === 'undefined') {
            // Makes non-existent property reactive
            this._vm.$set(state.report, 'referrals', []);
        }

        state.report.referrals.push({
            id: id,
            name: '',
            phone: '',
            email: '',
            comments: '',
            images: [],
            data_type: 'Models\\ServiceAppointments\\Reports\\ServiceAppointmentReportReferral',
        });
    },
    SET_REFERRAL_DATA (state, data) {
        let keys = Object.keys(data.data);

        for (let i = 0; i < keys.length; i++) {
            // Makes non-existent property reactive
            this._vm.$set(state.report.referrals[data.index], keys[i], data.data[keys[i]]);
        }
    },
    REMOVE_REFERRAL (state, index) {
        state.report.referrals.splice(index, 1);
    },
    ADD_REFERRAL_FILE (state, data) {
        // A hack for uninitialized field
        if (data.file !== null) {
            state.report.referrals[data.index][data.field].push(data.file);
        }
    },
    REMOVE_REFERRAL_FILE (state, data) {
        state.report.referrals[data.index][data.field].splice(data.fileIndex, 1);
    },
};
